/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Trainer_BuildsInputs */

const en_us2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let the trainer build it`)
};

const pt_br2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal monta para mim`)
};

const es_419_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que lo arme el entrenador`)
};

const pt_pt2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador monta-o`)
};

const fr_fr2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laisser le coach le faire`)
};

const de_de2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach baut ihn für mich`)
};

const it_it2_plan_build_trainer_builds = /** @type {(inputs: Plan_Build_Trainer_BuildsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La crea il coach`)
};

/**
* | output |
* | --- |
* | "Let the trainer build it" |
*
* @param {Plan_Build_Trainer_BuildsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_trainer_builds = /** @type {((inputs?: Plan_Build_Trainer_BuildsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Trainer_BuildsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_trainer_builds(inputs)
	if (locale === "es-419") return es_419_plan_build_trainer_builds(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_trainer_builds(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_trainer_builds(inputs)
	if (locale === "de-DE") return de_de2_plan_build_trainer_builds(inputs)
	if (locale === "it-IT") return it_it2_plan_build_trainer_builds(inputs)
	return en_us2_plan_build_trainer_builds(inputs)
});
export { plan_build_trainer_builds as "plan-build.trainer_builds" }